import StickerApi from '@/api/sticker'
import SurveyApi from '@/api/survey'
import WpWebhookApi from '@/api/wpWebhook'
import GlobalConfigurationApi from '@/api/global-configuration'
import AdsCampaignApi from '@/api/adsCampaign'
import TemplateCollectionApi from '@/api/template-collection'
import ScimApi from '@/api/scim'
import PresentationsApi from '@/api/presentations'
import AccountsApi from '@/api/accounts'

const initResources = () => {
  StickerApi.initResource()
  SurveyApi.initResource()
  WpWebhookApi.initResource()
  GlobalConfigurationApi.initResource()
  AdsCampaignApi.initResource()
  TemplateCollectionApi.initResource()
  ScimApi.initResource()
  PresentationsApi.initResource()
  AccountsApi.initResource()
}

export default {
  initResources,
}
